import React, { type ReactNode } from "react";
import * as styles from "src/components/SelectV2/SelectV2.style.ts";
import { ChipV2 } from "src/components/ChipV2/ChipV2.tsx";
import type { Option } from "src/components/SelectV2/SelectV2.types.ts";
import { SpinnerSpinningMini as Spinner } from "src/lib/ui-icon-v2";

export const MultiplePreview = <Value = unknown,>({
  value,
  flatOptions,
  onValueChange,
  placeholder,
  isLoadingData,
  isLoadingSelectedOption,
  fallbackOptions,
  truncateOptions = false,
  disabled,
}: {
  value: Value[] | "";
  flatOptions: Option<Value>[];
  onValueChange: (value: Value[] | "") => void;
  placeholder?: ReactNode;
  isLoadingData?: boolean;
  isLoadingSelectedOption: boolean;
  fallbackOptions: Option<NoInfer<Value>>[];
  truncateOptions?: boolean;
  disabled: boolean;
}) => {
  const hasSelectOptions = Array.isArray(value) && value.length > 0;
  return (
    <div
      css={styles.multiSelectPreviewContainer({
        truncateOptions: truncateOptions,
        disabled,
        hasValue: hasSelectOptions,
      })}
    >
      {isLoadingSelectedOption ? (
        <Spinner />
      ) : hasSelectOptions ? (
        (value || []).map((elementValue, index) => {
          const selectedOption = [...flatOptions, ...fallbackOptions].find(
            (o) => o.value === elementValue,
          );
          return (
            <ChipV2
              key={index}
              label={selectedOption?.label}
              disabled={disabled}
              css={styles.chip({ truncateOptions, disabled })}
              onPointerDown={(ev) => {
                ev.stopPropagation();
              }}
              onClick={(ev) => {
                ev.stopPropagation();
              }}
              onDelete={() => {
                const nextValues = value.filter((o) => elementValue !== o);
                onValueChange(nextValues);
              }}
            />
          );
        })
      ) : (
        <div css={styles.placeholderText}>{placeholder}</div>
      )}
    </div>
  );
};
